export default "__VITE_ASSET__DHYlQ61Y__"